import {FormattedMessage} from 'react-intl';
import {observer} from 'mobx-react';
import {Avatar, Button} from 'shared/components';
import {QuestionFieldFactory, AnswerResults} from 'main/components/forms';
import {t} from 'shared/core';
import _ from 'lodash';
import EntryRightMenu from './EntryRightMenu';

const SaveButton = ({detailsState, entry}) => {
  return (
    <Button size='sm' trait='primary' onClick={async () => detailsState.updateEntry(entry)}>
      <FormattedMessage id='recruiting.hiring_funnel.UPDATE_ENTRY' values={{entry: t('recruiting.hiring_funnel.Feedback')}} />
    </Button>
  );
};

const EditInterviewGuideResponse = observer(({entry, detailsState}) => {
  const errors = detailsState.editedEntryErrors;
  const {editedEntry} = detailsState;

  return (
    <div className='flex gap-6 border-top p3'>
      <Avatar employee={entry.user} size='sm'/>
      <div className='flex-1'>
        {editedEntry.sortedAnswers.map((answer, index) =>
          <div className='mb3' key={answer.question.id}>
            <QuestionFieldFactory
              errorMessage={_.get(errors, `answers.${index}.content`)}
              answer={answer}
              required={detailsState.calculateQuestionRequired(answer.question)}
              uiState={detailsState}
            />
          </div>
        )}
        <div className='flex justify-end align-items-center my2'>
          <Button trait='default' size='sm' className='px2' onClick={() => detailsState.cancelInput()}>
            <FormattedMessage id='recruiting.hiring_funnel.Cancel'/>
          </Button>
          <SaveButton entry={entry} detailsState={detailsState}/>
        </div>
      </div>
    </div>
  );
});

const InterviewGuideResponseEntry = observer(({entry, detailsState}) => {
  if (detailsState.isBeingEdited(entry)) {
    return <EditInterviewGuideResponse detailsState={detailsState} entry={entry}/>;
  }

  return (
    <div className='flex gap-6 border-top p3'>
      <Avatar employee={entry.user} size='sm'/>
      <div className='flex-1'>
        <div className='flex justify-between'>
          <div>
            <div className='flex items-center gap-2'>
              <div className='h3 medium'>{entry.interviewGuide.name}</div>
              <div className='h5 jumbo'>{entry.date}</div>
            </div>
            <div className='h5 jumbo'>{entry.name}</div>
          </div>
          <EntryRightMenu detailsState={detailsState} entry={entry}/>
        </div>
        <div className='pt2 whitespace-pre-line'>
          <AnswerResults answers={entry.sortedAnswers} />
        </div>
      </div>
    </div>
  );
});

export default InterviewGuideResponseEntry;
